import { createBlock, defineBlock } from "eddev/blocks"

export const meta: BlockMeta = {
  title: "Long Description",
  tags: ["film-text"],
  icon: "format-aside",
  description: "The long description of the film, imported from Airtable.",
  category: "Film",
  conditions: {
    multiple: false,
    postTypes: ["film"],
  },
}

export default defineBlock("film/film-long-description", (props) => {
  let contents = (
    <div className="film-description mb-4">
      <div dangerouslySetInnerHTML={{ __html: props.film?.descriptions?.long ?? "" }} />
    </div>
  )

  return contents
})
